import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, ScrollView, Platform } from 'react-native';
import { colores, fuentes } from '../../../../styles/variablesCss';

const RecuperarContrasena = ({ onSubmit, isLoading = false, error = '' }) => {
  const [email, setEmail] = useState('');

  const handleEnviar = () => {
    if (isLoading) return;
    if (typeof onSubmit === 'function') {
      onSubmit(email);
    }
  };

  return (
    <View style={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={styles.formContainer}>
          <View style={styles.inputContainer}>
            <Text style={styles.label}>Correo electrónico</Text>
            <View style={styles.inputPillContainer}>
              <TextInput
                style={styles.textInput}
                value={email}
                onChangeText={setEmail}
                placeholder="Ingresá tu correo electrónico"
                placeholderTextColor="#A0A0A0"
                autoCapitalize="none"
                keyboardType="email-address"
                autoComplete="email"
                textContentType="emailAddress"
              />
            </View>
          </View>
        </View>

        {error ? <Text style={styles.errorText}>{error}</Text> : null}

        <View style={styles.actionsRow}>
          <TouchableOpacity style={[styles.sendButton, isLoading ? styles.sendButtonDisabled : null]} onPress={handleEnviar} disabled={isLoading}>
            <Text style={styles.sendButtonText}>{isLoading ? 'Enviando...' : 'Enviar'}</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colores.blanco,
  },
  formContainer: {
    padding: 20,
    maxWidth: '100%',
  },
  inputContainer: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    color: colores.texto,
    marginBottom: 8,
    fontFamily: fuentes.medium,
  },
  inputPillContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#E5E5E5',
    backgroundColor: colores.blanco,
    borderRadius: 21,
    paddingHorizontal: 10,
  },
  textInput: {
    flex: 1,
    height: 42,
    paddingHorizontal: 12,
  },
  actionsRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 10,
    paddingHorizontal: 20,
    marginBottom: 20,
  },
  sendButton: {
    backgroundColor: 'red',
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 6,
    alignItems: 'center',
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 4,
          elevation: 3,
        }
    ),
  },
  sendButtonText: {
    color: colores.blanco,
    fontFamily: fuentes.bold,
    fontSize: 14,
  },
  sendButtonDisabled: {
    opacity: 0.7,
  },
  errorText: {
    color: colores.rojo,
    fontSize: 12,
    fontFamily: fuentes.medium,
    paddingHorizontal: 20,
    marginTop: -6,
    marginBottom: 6,
  },
});

export default RecuperarContrasena;
